<div>
  <div class="widget widget-fullwidth widget-small">
    <div
      id="table1_wrapper"
      class="dataTables_wrapper form-inline dt-bootstrap no-footer"
    >
      <div class="row am-datatable-body">
        <div class="col-sm-12">
          <table
            id="simulation-table"
            datatable
            [dtOptions]="dtOptions"
            [dtTrigger]="dtTrigger"
            class="row-border hover"
          >
            <thead>
              <tr>
                <th class="title tituloColumna">User</th>
                <th class="title tituloColumna">Customer</th>
                <th class="title tituloColumna">Region</th>
                <th class="title tituloColumna">Project</th>
                <th class="title tituloColumna">Simulation</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="dt-row"
                *ngFor="let sim of simulations"
                [class.selected]="sim === selectedSimulation"
                (click)="onRowClick(sim)"
                (dblclick)="onRowDblClick(sim)"
              >
                <td [attr.title]="sim.user.name">{{ sim.user.name }}</td>
                <td [attr.title]="sim.customer.name">{{ sim.customer.name }}</td>
                <td [attr.title]="sim.region.name">{{ sim.region.name }}</td>
                <td [attr.title]="sim.project.name">{{ sim.project.name }}</td>
                <td [attr.title]="sim.name">{{ sim.name }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
